<template>
  <div v-if="isShow.isPTShow" class="pg2">
    <Nav @nav="handleNav" :activeNum="2" />
    <div class="pg2-title"></div>
    <div class="pg2-article-title1">
      <img src="./img/pg2-title-sub-inner.png" alt="">
    </div>
    <div class="pg2-article1">
      <div class="slider-wrapper">
        <slider :imgCollection="slidesCollection" />
      </div>
    </div>
    <div class="pg2-article-title2">
      <img src="./img/pg2-title-sub2-inner.png" alt="">
    </div>
    <div class="pg2-article2">
      <div class="slider-wrapper2">
        <slider :imgCollection="slidesCollection2" />
      </div>
    </div>
    <div class="pg2-article-title3"></div>
    <div class="pg2-article3">
      <div class="pg2-article-c" ref="article"></div>
      <div class="pg2-article-table" ref="table">
        <div class="pg2-table-p1"></div>
        <div class="pg2-table-p2"></div>
        <div class="pg2-table-p3"></div>
        <div class="pg2-table-t1"></div>
        <div class="pg2-table-t2"></div>
        <div class="pg2-table-t3"></div>
      </div>
      <div class="slider-wrapper3">
        <slider :imgCollection="slidesCollection3" />
      </div>
    </div>
    <div class="bg-bottom">
      <div class="bg-bottom-inner">
        <div class="btn-wp" @click="vote">
          <span class="icon-thumb"></span>
          <span class="btn-num">{{num}}</span>
        </div>
        <p class="btn-desc">点赞</p>
        <div class="btn-back" @click="goBack">返回</div>
      </div>
    </div>
    <toast :toastMsg="msg" :ms="time" :isTrigger="trigger" />
  </div>
</template>

<script>
import Slider from '../../components/slider/slider';
import Nav from '../../components/navBar/navBar'
import { postData } from '../../assets/util'
import Toast from '../../components/toast/toast'

export default {
  name: 'PageTwo',
  props: {
    isShow: Object
  },
  data() {
    return {
      num: 0,
      trigger: false,
      msg: '',
      time: 1500,
      slidesCollection: [{
        src: require('../page-one/img/p1-c1-p1.jpg'),
      }, {
        src: require('../page-one/img/p1-c1-p2.jpg'),
      }, {
        src: require('../page-one/img/p1-c1-p3.jpg'),
      }, {
        src: require('../page-one/img/p1-c1-p4.jpg'),
      }, ],
      slidesCollection2: [{
        src: require('../page-one/img/p1-c2-p1.jpg'),
      }, {
        src: require('../page-one/img/p1-c2-p2.jpg'),
      }, {
        src: require('../page-one/img/p1-c2-p3.jpg'),
      }, {
        src: require('../page-one/img/p1-c2-p4.jpg'),
      }, {
        src: require('../page-one/img/p1-c2-p5.jpg'),
      }, ],
      slidesCollection3: [{
        src: require('../page-one/img/p1-c3-p1.jpg'),
      }, {
        src: require('../page-one/img/p1-c3-p2.jpg'),
      }, {
        src: require('../page-one/img/p1-c3-p3.jpg'),
      }, {
        src: require('../page-one/img/p1-c3-p4.jpg'),
      }, {
        src: require('../page-one/img/p1-c3-p5.jpg'),
      }, ]
    }
  },
  components: {
    Slider,
    Nav,
    Toast
  },
  methods: {
    showNext () {
      this.$emit('nextPage', 'isKVShow')
    },
    goBack() {
      setTimeout(() => {
        this.$emit('nextPage', 'isPOShow')
      }, 300)
    },
    handleNav(msg) {
      this.$emit('nextPage', msg);
    },
    notify(msg, time) {
      this.trigger = !this.trigger;
      this.msg = msg || '';
      this.time = time || 1500;
    },
    getNumber() {
      const URL = '/codes/2020/nfdw/game.php/Home/Index/JDOU_articleZan';
      const myData = {articleId: 1};
      postData(URL, myData)
        .then(res => {
          if (res.status === 1) {
            let tempNum = parseInt(res.zanNum);
            this.num = tempNum;
          } else {
            const txt = res.msg || '获取失败';
            this.notify(txt);
          }
        })
        .catch(err => {
          this.notify('获取出错')
        })
    },
    vote() {
      const URL = '/codes/2020/nfdw/game.php/Home/Index/JDOU_zan';
      const myData = {articleId: 1};
      postData(URL, myData)
        .then(res => {
          if (res.status === 1) {
            this.notify('点赞成功');
            this.num += 1;
          } else {
            const txt = res.msg || '点赞失败';
            this.notify(txt);
          }
        })
        .catch(err => {
          this.notify('点赞出错')
        })
    },
  },
  created() {
    this.getNumber();
  },
  watch: {
    'isShow.isPTShow': function () {
      window.scroll(0, 0);
      setTimeout(() => {
        if (this.isShow.isPTShow) {
          const art = document.querySelector('.pg2-article-c');
          const table = document.querySelector('.pg2-article-table');
          window.addEventListener('scroll', () => {
            if (this.isShow.isPTShow) {
              const dis = art.getBoundingClientRect().top;
              if (dis < 150) {
                table.classList.add('table-play');
              }
            }
          })
          table.classList.remove('table-play');
        } else {
          const art = document.querySelector('.pg2-article-c');
          const table = document.querySelector('.pg2-article-table');
          window.removeEventListener('scroll', () => {
            if (this.isShow.isPTShow) {
              const dis = art.getBoundingClientRect().top;
              if (dis < 150) {
                table.classList.add('table-play');
              }
            }
          })
        }
      }, 200)
    }
  }
}
</script>

<style lang="less" scoped>
.bg(@url) {
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url(@url);
}
.pg2 {
  box-sizing: border-box;
  padding-top: 1.875rem /* 30/16 */;
  min-height: 100vh;
  background-color: #012bad;
}
.pg2-title {
  width: 23.4375rem /* 375/16 */;
  height: 22.25/2rem /* 356/16 */;
  .bg('./img/pg2-title.png');
}
.pg2-article-title1 {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  margin-bottom: .625rem /* 10/16 */;
  width: 333px;
  height: 81px;
  background-image: url('../page-one/img/title.png');
  background-repeat: no-repeat;
  background-position-x: 0;
  animation: titleAni 1s steps(11) infinite;
  img {
    width: 17.3125/2rem /* 277/16 */;
    height: 2.4375/2rem /* 39/16 */;
  }
}
.pg2-article1 {
  position: relative;
  margin: 0 auto;
  width: 42.8125/2rem /* 685/16 */;
  height: 57.75/2rem /* 924/16 */;
  .bg('./img/pg2-article1.png');
}
.pg2-article-title2 {
  margin: 1.875rem /* 30/16 */ auto;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 333px;
  height: 81px;
  background-image: url('../page-one/img/title.png');
  background-repeat: no-repeat;
  background-position-x: 0;
  animation: titleAni 1s steps(11) infinite;
  img {
    width: 17.1875/2rem /* 275/16 */;
    height: 1.25rem /* 20/16 */;
  }
}
.pg2-article2 {
  position: relative;
  margin: 0 auto;
  width: 42.8125/2rem /* 685/16 */;
  height: 59.3125/2rem /* 949/16 */;
  .bg('./img/pg2-article2.png');
}
.pg2-article-title3 {
  margin: 1.875rem /* 30/16 */ auto;
  width: 333px;
  height: 100px;
  background-repeat: no-repeat;
  background-image: url('./img/title2.png');
  animation: titleAni2 1s steps(7) infinite;
}
.pg2-article3 {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  padding-top: 2.5rem /* 40/16 */;
  margin: 0 auto;
  margin-bottom: 1.875rem /* 30/16 */;
  width: 42.8125/2rem /* 685/16 */;
  height: 88.6875/2rem /* 1419/16 */;
  .bg('./img/pg2-article3-bg.png');
  .pg2-article-c {
    width: 37.5625/2rem /* 601/16 */;
    height: 11.25rem /* 180/16 */;
    .bg('./img/pg2-article3-c1.png');
  }
}
.pg2-article-table {
  position: relative;
  margin-top: 1.875rem /* 30/16 */;
  width: 31.375/2rem /* 502/16 */;
  height: 22.875/2rem /* 366/16 */;
  // background-image: url('./img/pg2-table.png');
  background-size: cover;
  background-repeat: no-repeat;
}
.table-play {
  .pg2-table-p1, .pg2-table-p2, .pg2-table-p3 {
    transform: translate(0, 0);
    opacity: 1;
  }
  .pg2-table-t1, .pg2-table-t2, .pg2-table-t3 {
    opacity: 1;
  }
}
.pg2-table-p1 {
  position: absolute;
  left: 2rem;
  top: 2.8rem;
  width: 13.625/2rem /* 218/16 */;
  height: 7.0625/2rem /* 113/16 */;
  .bg('./img/pg2-table-part1.png');
  transition: all .3s ease-out;
  transform: translate(-40px, -20px);
  opacity: 0;
}
.pg2-table-p2 {
  position: absolute;
  right: .2rem;
  top: 2.6rem;
  width: 13.5625/2rem /* 217/16 */;
  height: 11.4375/2rem /* 183/16 */;
  .bg('./img/pg2-table-part2.png');
  transition: all .3s ease-out;
  transform: translate(40px, -20px);
  opacity: 0;
}
.pg2-table-p3 {
  position: absolute;
  bottom: 3rem;
  left: 2rem;
  width: 17.9375/2rem /* 287/16 */;
  height: 6.25/2rem /* 100/16 */;
  .bg('./img/pg2-table-part3.png');
  transition: all .3s ease-out;
  transform: translate(-20px, 30px);
  opacity: 0;
}
.pg2-table-t1 {
  position: absolute;
  left: 0;
  top: 0;
  width: 16.125/2rem /* 258/16 */;
  height: 8.125/2rem /* 130/16 */;
  .bg('./img/pg2-table-part1-txt.png');
  opacity: 0;
  transition: all .3s ease-out .4s;
}
.pg2-table-t2 {
  position: absolute;
  right: 0;
  top: 0;
  width: 12.375/2rem /* 198/16 */;
  height: 8.4375/2rem /* 135/16 */;
  .bg('./img/pg2-table-part2-txt.png');
  opacity: 0;
  transition: all .3s ease-out .6s;
}
.pg2-table-t3 {
  position: absolute;
  bottom: 0;
  left: 2.6rem;
  width: 11.5/2rem /* 184/16 */;
  height: 7.4375/2rem /* 119/16 */;
  .bg('./img/pg2-table-part3-txt.png');
  opacity: 0;
  transition: all .3s ease-out .8s;
}
.bg-bottom {
  width: 23.4375rem /* 375/16 */;
  height: 43.1875/2rem /* 691/16 */;
  background: linear-gradient(to bottom, #012bad 1%, #5d46ac 40%, #a95ece 99%);
  .bg-bottom-inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: 100%;
    .bg('./img/p2-bottom-bg.png');
  }
}
.btn-wp {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 6.25rem /* 100/16 */;
  height: 6.25rem /* 100/16 */;
  border-radius: 50%;
  background: linear-gradient(135deg, #ffcb04 1%, #faa711 50%, #fe9c21 100%);
  box-shadow: 0 0 6px 0 #5e50a3;
  transition: opacity .3s;
  &:active {
    opacity: .8;
  }
}
.icon-thumb {
  display: inline-block;
  width: 7.125/2rem /* 114/16 */;
  height: 7.25/2rem /* 116/16 */;
  margin-top: .375rem /* 6/16 */;
  .bg('./img/pg2-thumb.png');
}
.btn-num {
  font-size: .875rem /* 14/16 */;
  font-weight: bold;
  color: #fff;
}
.btn-desc {
  margin: 1rem 0;
  color: #fff;
  font-size: .875rem /* 14/16 */;
  font-weight: bold;
}
.btn-back {
  box-sizing: border-box;
  width: 9.375rem /* 150/16 */;
  border-radius: 1.875rem /* 30/16 */;
  font-size: .875rem /* 14/16 */;
  font-weight: bold;
  color: #fff;
  line-height: 2;
  text-align: center;
  border: 1px solid #fff;
  transition: opacity .3s;
  &:active {
    opacity: .8;
  }
}
.slider-wrapper {
  position: absolute;
  left: 51%;
  bottom: 2.5rem;
  box-sizing: border-box;
  width: 36.75/2rem /* 588/16 */;
  height: 20/2rem /* 320/16 */;
  overflow: hidden;
  border-radius: .5rem /* 8/16 */;
  transform: translateX(-50%);
}
.slider-wrapper2, .slider-wrapper3 {
  position: absolute;
  left: 1.5rem;
  bottom: 4rem;
  box-sizing: border-box;
  width: 36.875/2rem /* 590/16 */;
  height: 25.0625/2rem /* 401/16 */;
  overflow: hidden;
  border-radius: .5rem /* 8/16 */;
}
.slider-wrapper3 {
  bottom: 3rem;
}
@keyframes titleAni {
  from {
    background-position-x: 0;
  }
  to {
    background-position-x: -3663px;
  }
}
@keyframes titleAni2 {
  from {
    background-position-x: 0;
  }
  to {
    background-position-x: -2331px;
  }
}
</style>
